import React, {useEffect, useMemo, useRef, useState} from "react";
import {useSubheader} from "../../../../_metronic/layout";
import {OrderEditForm} from "./OrderEditForm";
import {useOrdersUIContext} from "../OrdersUIContext";
import {getOrder} from "../crud/orderCrud";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
    ModalProgressBar
} from "../../../../_metronic/_partials/controls";
import {Tab, Tabs} from "react-bootstrap";
import {shallowEqual, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";


export default function OrderEdit({id}) {

    // Subheader
    const suhbeader = useSubheader();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [title, setTitle] = useState("");
    const orderContext = useOrdersUIContext();
    const orderUIProps = useMemo(() => {
        return {
            order: orderContext.order,
            setOrder: orderContext.setOrder,
            setError: orderContext.setError,
            setOpenError: orderContext.setOpenError,
        };
    }, [orderContext]);

    const {actionsLoading} = useSelector(
        (state) => ({
            actionsLoading: state.actionsLoading.actionsLoading,
        }),
        shallowEqual
    );

    useEffect(() => {
        let _title = id !== 'new' ? "" : "سفارش جدید";
        if (id !== 'new') {
            getOrder(id)
                .then((response) => {
                    orderUIProps.setOrder(response.data.data);
                    setIsLoading(false);
                })
        } else {
            setIsLoading(false);
        }
        setTitle(_title);
        suhbeader.setTitle(_title);
    }, [id]);


    const backToProductsList = () => {
        history.push('/customer/orders')
    };

    return (
        <>
            {!isLoading &&
            <Card>
                {actionsLoading && <ModalProgressBar/>}
                <CardHeader title={title}>
                    <CardHeaderToolbar>
                        {/*<button*/}
                        {/*    type="submit"*/}
                        {/*    className="btn btn-primary ml-2"*/}
                        {/*    onClick={saveProductClick}*/}
                        {/*>*/}
                        {/*    ذخیره*/}
                        {/*</button>*/}
                        <button
                            type="button"
                            onClick={backToProductsList}
                            className="btn btn-light ml-2"
                        >
                            بازگشت
                            <i className="fa fa-arrow-left ml-2"/>
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Tabs defaultActiveKey="basic" className="nav nav-tabs nav-tabs-line " role="tablist">
                        <Tab eventKey="basic" title="اطلاعات">
                            <div className="mt-5">
                                <OrderEditForm
                                    order={orderUIProps.order}
                                />
                            </div>
                        </Tab>

                    </Tabs>
                </CardBody>
            </Card>
            }
        </>

    );
}
